module.exports = __webpack_public_path__ + "assets/plugdown.3d970558.svg";